import { TableColumn } from "PFTypes";
import { OrderOptionOrEmpty } from "PFTypes/meta";
import { StoreApi } from "zustand";

export enum WorkflowTab {
  Engagements = "engagements",
  Roles = "roles",
  Planner = "planner"
}

export type WorkflowActivityTab = WorkflowTab.Roles | WorkflowTab.Engagements;

export type EngagementsModalKey = "share" | "bulkEdit" | "smartAllocation" | "rollForward";

export type RolesModalKey = "share" | "bulkEdit" | "smartAllocation" | "closeRoles";

export type EngagementsState = {
  columns: string[];
  resolvedColumns: TableColumn[];
  order: OrderOptionOrEmpty;
  currentPage: number;
  groupBy: string | null;
  pinnedIds: number[];
  selectedIds: Record<string, true>;
  modals: Record<EngagementsModalKey, boolean>;
};

export type RolesState = {
  columns: string[];
  resolvedColumns: TableColumn[];
  order: OrderOptionOrEmpty;
  currentPage: number;
  groupBy: string | null;
  pinnedIds: number[];
  selectedIds: Record<string, true>;
  ganttView: boolean;
  modals: Record<RolesModalKey, boolean>;
};

export type PlannerState = {
  selectedOrder: OrderOptionOrEmpty;
  currentPage: number;
};

export type WorkflowState = {
  tab: WorkflowTab;
  permittedTabs: WorkflowTab[];
  engagements: EngagementsState;
  roles: RolesState;
  planner: PlannerState;
};

export type EngagementsActions = {
  setColumns: (columns: TableColumn[]) => void;
  setOrder: (order: OrderOptionOrEmpty) => void;
  setCurrentPage: (page: number) => void;
  setGroupBy: (groupBy: string | null) => void;
  setPinnedIds: (ids: number[]) => void;
  setSelectedIds: (
    ids: Record<string, true> | ((selectedIds: Record<string, true>) => Record<string, true>)
  ) => void;
  setModalVisibility: (modal: EngagementsModalKey, visible: boolean) => void;
};

export type RolesActions = {
  setColumns: (columns: TableColumn[]) => void;
  setOrder: (order: OrderOptionOrEmpty) => void;
  setCurrentPage: (page: number) => void;
  setGroupBy: (groupBy: string | null) => void;
  setPinnedIds: (ids: number[]) => void;
  setSelectedIds: (
    ids: Record<string, true> | ((selectedIds: Record<string, true>) => Record<string, true>)
  ) => void;
  setGanttView: (ganttView: boolean) => void;
  setModalVisibility: (modal: RolesModalKey, visible: boolean) => void;
};

export type PlannerActions = {
  setSelectedOrder: (order: OrderOptionOrEmpty) => void;
  setCurrentPage: (page: number) => void;
};

export type WorkflowActions = {
  setTab: (tab: WorkflowTab) => void;
  setPermittedTabs: (tabs: WorkflowTab[]) => void;
  engagements: EngagementsActions;
  roles: RolesActions;
  planner: PlannerActions;
};

export type WorkflowStoreType = WorkflowState & { actions: WorkflowActions };

export type WorkflowContextType = StoreApi<WorkflowStoreType>;
